// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__1ARYW","formSpace":"styles_formSpace__2CX6P","actionButton":"styles_actionButton__1FCPA","actionIcon":"styles_actionIcon__m0GLq"};